/** native — EN source (client-mobile-only strings). */
export const native = {
  // Discover tab + nearby map
  native_discover_title: "Discover",
  native_discover_people_nearby: "People nearby",
  native_discover_finding_people: "Finding people nearby...",
  native_discover_start_swiping: "Start swiping to connect",
  native_discover_none_nearby: "No one nearby right now. Try again later!",
  native_discover_within_radius: "{count} {noun} within {radius} mi",
  native_discover_count_nearby: "{count} {noun} nearby",
  native_discover_person: "person",
  native_discover_people: "people",
  native_discover_location_unavailable: "Location not available",
  native_discover_spots_nearby: "{count} spots nearby",
  native_discover_map_mobile_only: "Map available on mobile",

  // Settings — push notification status
  native_settings_push_not_supported: "Not supported on this device",
  native_settings_push_permission_denied: "Permission denied",
  native_settings_push_enabled: "Enabled",
  native_settings_push_disabled: "Disabled",

  // Settings — business section
  native_settings_business_section: "Business",
  native_settings_business_mode_title: "Business Mode",
  native_settings_business_mode_subtitle: "Create or manage your business",

  // Settings — mini apps section
  native_settings_mini_apps_section: "Mini Apps",
  native_settings_manage_mini_apps_title: "Manage Mini Apps",
  native_settings_manage_mini_apps_subtitle:
    "View, create, and manage mini apps",

  // Chat
  native_chat_no_messages_title: "No messages yet",
  native_chat_no_messages_description:
    "When you match with someone, you can start a conversation here",
  native_chat_tap_to_retry: "Tap to retry",

  // Match / filters / match-location
  native_match_approximate_location: "Approximate location",
  native_match_approximate_location_help:
    "When on, others see only a fuzzed area near you, not your exact spot. Your precise location is never shared.",
  native_match_invalid_match: "Invalid match",
  native_match_you_label: "You:",

  // Mini app view
  native_miniapp_load_failed: "Couldn't load {appId}",
  native_miniapp_retry: "Retry",
};
